import { render, staticRenderFns } from "./UpdateUserGroupModal.vue?vue&type=template&id=ff13485a&scoped=true&"
import script from "./UpdateUserGroupModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserGroupModal.vue?vue&type=style&index=0&id=ff13485a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff13485a",
  null
  
)

export default component.exports